import React from "react";
import { useHandlerContext } from "./providers/Handler";
import { faLoader } from "../../utilities/fontawesomeIcons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Rating from "../../Components/Rating/Rating";
import { Index as IndexFeedbackItem } from "../FeedbackItems/Index";
import { IndexProvider as IndexFeedbackItemProvider } from "../FeedbackItems/providers/Index";
import ButtonUtility from "../../Components/Buttons/Utility";
import { useAppContext } from "../../AppProvider";

export const Handler = () => {
  const { data, loader, callback } = useHandlerContext();
  const { dictionary } = useAppContext();
  return (
    <React.Fragment>
      {loader ? (
        <div className="text-center mt-2">
          <FontAwesomeIcon icon={faLoader} spin size="2x" />
        </div>
      ) : (
        <React.Fragment>
          <label className="label-4 text-center mb-3">
            {dictionary.feedbacks.feedback}
          </label>

          {data.carrierName && (
            <div
              className="d-flex justify-content-center"
              style={{ height: "50px", width: "auto" }}
            >
              <>
                <img
                  src={data.carrierLogoImageUrl}
                  style={{
                    width: "auto",
                    height: "60%",
                    objectFit: "contain",
                  }}
                />
              </>
            </div>
          )}

          <div className="mb-2">
            {data.rating && (
              <div className="d-flex justify-content-center">
                <Rating value={data.rating} />
              </div>
            )}
          </div>

          {data.id && (
            <IndexFeedbackItemProvider id={data.id}>
              <IndexFeedbackItem />
            </IndexFeedbackItemProvider>
          )}

          <ButtonUtility
            className="w-100 me-2"
            onClick={() => {
              if (callback) {
                callback();
              }
            }}
            disabled={loader}
          >
            {dictionary.actions.close}
          </ButtonUtility>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Handler;
